export default () => ({
  Authorization: `Bearer ${localStorage.getItem('id_token')}`,
})
